import 'react-app-polyfill/stable';
import './polyfill';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './i18n';
import { configureStore } from './state';
import { registerAxiosInterceptors } from './utils/axios/axios-instance';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

export const store = configureStore();
registerAxiosInterceptors(store);

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
  // </React.StrictMode>
);

// Check if running in WebView
const isWebView = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('utilitytool') || // Utility Tool WebView
         userAgent.includes('wv') || // Android WebView
         (userAgent.includes('mobile') && userAgent.includes('safari') && !userAgent.includes('chrome')) || // iOS WebView
         userAgent.includes('electron') || // Electron WebView
         userAgent.includes('cordova') || // Cordova/PhoneGap
         userAgent.includes('capacitor') || // Capacitor
         userAgent.includes('react-native') || // React Native WebView
         (window as any).ReactNativeWebView !== undefined; // React Native WebView global
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (isWebView()) {
  console.log('🚫 WebView detected - skipping Service Worker registration');
  console.log('💡 In WebView, updates are handled by the native app, not service workers');
} else {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log('Service Worker registered successfully:', registration);
    },
    onUpdate: (registration) => {
      console.log('Service Worker update available:', registration);
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
